<template>
  <div class="fix-left" v-if="isShow">
    <radishDetail v-if="rid" :id="rid" type="left"></radishDetail>
    <div class="fix-middle-actions"><el-button circle size="mini" icon="el-icon-close" @click="close"></el-button></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isShow: false,
      rid: '',
    }
  },
  methods: {
    show: function(rid) {
      this.rid = rid
      this.isShow = true
    },
    close: function() {
      this.isShow = false
    },
  },
}
</script>
<style>
.fix-left {
  width: 40vw;
  position: fixed;
  top: 0;
  left: 0;
  background-color: #fff;
  z-index: 1003;
}
</style>
